import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { formSubmitPublicEntrypoint } from '@atlassian/jira-spa-apps-form-submit-public/entrypoint.tsx';

export const formSubmitPageEntrypoint = createChromelessEntryPoint({
	main: formSubmitPublicEntrypoint,
});
